import { cloneProviderClient, unwrap } from './cloneProviderClient';

export async function listPurchases(params = {}) {
  const response = await cloneProviderClient.get('/admin/purchases', { params });
  return unwrap(response);
}

export async function listProductEvaluations(params = {}) {
  const response = await cloneProviderClient.get('/admin/product-evaluations', { params });
  return unwrap(response);
}

export async function recomputeEvaluations(numAccountsToCalcScore) {
  const params = {};
  if (numAccountsToCalcScore != null) params.num_accounts_to_calc_score = numAccountsToCalcScore;
  const response = await cloneProviderClient.post('/admin/product-evaluations/recompute', null, { params });
  return unwrap(response);
}

export async function buyNow({ website, externalId, amount }) {
  const response = await cloneProviderClient.post('/admin/purchases/buy', {
    website,
    external_id: externalId,
    amount,
  });
  return unwrap(response);
}

const purchasesService = { listPurchases, listProductEvaluations, recomputeEvaluations, buyNow };
export default purchasesService;
